<template v-if="componentAccess.canEdit.access">
  <div @click="onClick">
    <router-link
        v-if="this.schema.buttonOptions.route"
        :to="route"
    >
      <font-awesome-icon :icon="[prefix, iconName]"/>
    </router-link>

    <a v-if="!this.schema.buttonOptions.route">
      <font-awesome-icon :icon="[prefix, iconName]"/>
    </a>

  </div>
</template>

<script>
import abstractField from 'vue-form-generator/src/fields/abstractField';
import CanAccessMixin from "@/components/mixins/CanAccessMixin";

export default {
  mixins: [abstractField, CanAccessMixin],
  data() {
    return {
      componentAccess: {
        canEdit: {
          route: '',
          access: false,
        },
      }
    }
  },
  computed: {
    prefix() {
      return this.schema.buttonOptions.icon.prefix;
    },
    iconName() {
      return this.schema.buttonOptions.icon.iconName;
    },
    route() {
      if (!this.schema.buttonOptions.route) {
        return '';
      }

      return {
        name: this.schema.buttonOptions.route.name,
        params: {
          [this.schema.buttonOptions.route.routeParam]: this.model.id
        }
      };
    },
  },
  methods: {
    async canAccessComponent() {
      if (!this.schema.buttonOptions.route) {
        return;
      }

      this.componentAccess.canEdit.access = await this.canAccessRoute(this.schema.buttonOptions.route.name);
    },
    onClick($event) {
      if (this.schema.onClick) {
        this.schema.onClick(this.model, this.schema, $event);
      }
    },
  }
};
</script>

<style lang="scss">
.awesome-form-button {
  .field-wrap {
    > div {
      border: 1px solid #444b57 !important;
      cursor: pointer;
      transition: all .4s ease-out;
    }
  }

  &.edit {
    .field-wrap {
      justify-content: flex-end;

      > div {
        padding: 2px 5.5px;
        border-radius: 20px;

        &:hover {
          border: 1px solid #242424 !important;
          background: #242424;

          svg {
            color: #fff;
          }
        }
      }
    }
  }

  &.delete {
    .field-wrap {
      justify-content: flex-start;

      > div {
        padding: 2px 8.13px;
        border-radius: 20px;

        &:hover {
          border: 1px solid #ff6f6f !important;
          background: #ff6f6f;

          svg {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
